import React from 'react'
import { Box, Chip, Stack } from '@mui/material'

const FilterChip = ({ label, count, active, onClick }) => {
  return (
    <Chip
      onClick={onClick}
      label={
        <Stack direction="row" spacing={0.75} alignItems="center">
          <span>{label}</span>
          {count != null && (
            <Box
              component="span"
              sx={{
                fontSize: 11,
                fontWeight: 700,
                color: active ? "#fff" : "text.secondary",
                opacity: active ? 0.9 : 0.7,
              }}
            >
              {count}
            </Box>
          )}
        </Stack>
      }
      sx={{
        bgcolor: active ? "#003C59" : "#fff",
        color: active ? "#fff" : "text.primary",
        border: active ? "none" : "1px solid #E3E7EE",
        fontWeight: 600,
        px: 0.5,
        "&:hover": { bgcolor: active ? "#003C59" : "#F5F6F8" },
      }}
    />
  )
}

export default FilterChip